import { render, staticRenderFns } from "./ArchiveGrid.vue?vue&type=template&id=7f975248&"
import script from "./ArchiveGrid.vue?vue&type=script&lang=js&"
export * from "./ArchiveGrid.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports